import { Check } from 'lucide-react';
import type { MouseEventHandler } from 'react';

export const STACKED_CONTAINER_CLASS = 'grid grid-cols-1 gap-3 max-w-2xl mx-auto';
const STACKED_TILE_CLASS =
  'flex items-center gap-4 p-3 border-2 rounded-lg transition-all duration-200';
const STACKED_LABEL_CLASS = 'w-1/3 shrink-0 flex items-center justify-between gap-2';
const STACKED_LABEL_TEXT_CLASS = 'text-sm font-medium text-gray-700';
const STACKED_IMAGE_BOX_CLASS = 'flex-1 flex justify-center min-w-0';
const STACKED_IMAGE_CLASS = 'max-h-[120px] w-auto max-w-full object-contain rounded-md';
const IMAGE_ERROR_HTML =
  '<div class="w-full h-16 flex items-center justify-center text-sm text-gray-500">Failed to load image</div>';

interface StackedPictureTileProps {
  label: string;
  src: string;
  alt: string;
  isSelected: boolean;
  stateClass: string;
  ariaDisabled?: boolean;
  onClick: MouseEventHandler<HTMLDivElement>;
}

export function StackedPictureTile({
  label,
  src,
  alt,
  isSelected,
  stateClass,
  ariaDisabled,
  onClick,
}: StackedPictureTileProps) {
  return (
    <div
      aria-disabled={ariaDisabled}
      className={`${STACKED_TILE_CLASS} ${stateClass}`}
      onClick={onClick}
    >
      <div className={STACKED_LABEL_CLASS}>
        <span className={STACKED_LABEL_TEXT_CLASS}>{label}</span>
        {isSelected && <Check className="h-5 w-5 text-blue-500 shrink-0" />}
      </div>
      <div className={STACKED_IMAGE_BOX_CLASS}>
        <img
          src={src}
          alt={alt}
          className={STACKED_IMAGE_CLASS}
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
            const parent = target.parentElement;
            if (parent) parent.innerHTML = IMAGE_ERROR_HTML;
          }}
        />
      </div>
    </div>
  );
}
